var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftArrowIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f70;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "infos_icons",
    "data-name": "infos icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "leftArrow"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_2-2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "projects_icons",
    "data-name": "projects icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "left_arrow",
    "data-name": "left arrow",
    className: "cls-1",
    d: "M62.87,29.27,34.55,48.05a2.33,2.33,0,0,0-.65,3.23,2.24,2.24,0,0,0,.65.65l28.32,18.8a2.33,2.33,0,0,0,3.62-1.94V31.22a2.34,2.34,0,0,0-2.32-2.34A2.39,2.39,0,0,0,62.87,29.27Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 100,
    height: 100
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowIcon);
export default __webpack_public_path__ + "static/media/leftArrowIcon.b67efb1133318ce49fc6753bfe4bc391.svg";
export { ForwardRef as ReactComponent };